(function () {
    'use strict';

    angular
        .module('FormBuilder')
        .directive('fbFieldToggle', fbFieldToggleFieldDirective);

    function fbFieldToggleFieldDirective() {
        return {
            restrict: "E",
            scope: {
                element: "=",
            },
            require: 'ngModel',
            templateUrl: 'common/libraries/formBuilder/fields/fieldToggle',
            link: function(scope, elem, attr, ctrl) {
                scope.currentScope = {
                    element: scope.element,
                };

                ctrl.$render = function() {
                    scope.currentScopeModel = ctrl.$viewValue;
                }

                scope.$watch('currentScopeModel', function() {
                   ctrl.$setViewValue(scope.currentScopeModel);
                });
            }
        };
    }
})();